var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.83317C7.01754 2.83317 4.54551 5.35526 4.54551 8.53464V8.54446L4.54545 8.54446L4.52262 10.4823C4.52147 11.813 4.06936 12.9387 3.54854 13.7725H16.4578C15.9576 12.9367 15.5243 11.8089 15.5243 10.4772V10.4668L15.5243 10.4668L15.5472 8.62587C15.5445 5.39569 13.0321 2.83317 10 2.83317ZM2.87884 8.52959C2.88147 4.49311 6.03879 1.1665 10 1.1665C14.0141 1.1665 17.2138 4.53898 17.2138 8.6309V8.64123L17.2138 8.64123L17.1909 10.4821C17.1922 11.6148 17.6274 12.5684 18.0893 13.2273C18.406 13.6791 18.3741 14.2175 18.2197 14.5946C18.0666 14.9683 17.6744 15.4392 17.025 15.4392H2.97593C2.31583 15.4392 1.92433 14.9539 1.77511 14.5783C1.62423 14.1984 1.5952 13.6511 1.92622 13.1983L2.599 13.69L1.92622 13.1983C2.40899 12.5378 2.85596 11.5931 2.85596 10.4772V10.4673L2.85601 10.4673L2.87884 8.52959ZM6.83574 16.6886C7.11362 16.3217 7.6363 16.2496 8.00318 16.5275C8.51672 16.9164 9.21474 17.1665 10 17.1665C10.7853 17.1665 11.4833 16.9164 11.9969 16.5275C12.3637 16.2496 12.8864 16.3217 13.1643 16.6886C13.4422 17.0555 13.3701 17.5781 13.0032 17.856C12.1898 18.4721 11.1356 18.8332 10 18.8332C8.86442 18.8332 7.81022 18.4721 6.99686 17.856C6.62999 17.5781 6.55785 17.0555 6.83574 16.6886Z",
    fill: "#1E2632"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.47d8e26760fc7449874345ed0bafc1be.svg";
export { ForwardRef as ReactComponent };